import styled from 'styled-components';

import { control } from '../../styles/mixins';

const Headline = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 2.2rem;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 1.2rem;

  > button:not(:last-child) {
    margin-right: 1.2rem;
  }
`;

const Input = styled.input`
  ${control}
  width: 100%;
  margin-top: 1.6rem;
`;

const Error = styled.p`
  color: var(--danger);
  margin-top: 0.5rem;
  margin-left: 1rem;
`;

const modalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export { Headline, Input, ButtonsContainer, Error, modalStyles };
